import type {ReactNode} from 'react';
import {Icon} from '../ui/Icon';
import {StatusBadge} from '../ui/StatusBadge';
import type {LifecycleStep} from '../ui/LifecycleProgress';
import {RepairFinance} from './RepairFinance';

type Props={inspectionOutcomes?:string[]|undefined;workId:string;building:string;version:number;status:string;evidence:ReactNode;steps:readonly LifecycleStep[]|null;selected:string;busy:boolean;onSelect:(step:string)=>void;unavailableReason:string};

/** Delivery, retained evidence and money are parallel facts. A delivery stage never
 * certifies evidence acceptance, invoice payment, recovery or governed closure. */
export function WorkMissionOverview({inspectionOutcomes,workId,building,version,status,evidence,steps,selected,busy,onSelect,unavailableReason}:Props){
 const inspectionStep=steps?.find(step=>step.id==='5');
 return <>
  <section className="work-mission-lanes" aria-label="Delivery, evidence and recovery">
   <article><h2><Icon name="wrench"/>Delivery</h2><StatusBadge text={status}/></article>
   <article><h2><Icon name="file-text"/>Evidence</h2>{evidence}</article>
   <article>
<h2>
<Icon name="clipboard-check"/>Inspection</h2>
<p>{inspectionOutcomes===undefined?'Inspection information not returned':inspectionOutcomes.length?inspectionOutcomes.length+' recorded inspection'+(inspectionOutcomes.length===1?'':'s'):'No inspection recorded'}</p>{Boolean(inspectionOutcomes?.length)&&<small>{[...new Set(inspectionOutcomes)].join(' · ')}</small>}
<button type="button" className="secondary" disabled={busy||!inspectionStep||inspectionStep.selectable===false}
 onClick={()=>{if(inspectionStep?.selectable!==false&&inspectionStep)onSelect(inspectionStep.id)}}>Review inspections</button>
</article>
   <article><h2><Icon name="wallet"/>Recovery & finance</h2><RepairFinance workId={workId} building={building} version={version}/></article>
  </section>
  {steps?<nav className="work-section-navigation" aria-label="Work record steps">{steps.map(step=><button type="button" key={step.id} aria-current={selected===step.id?'page':undefined} disabled={busy||step.selectable===false} onClick={()=>onSelect(step.id)} title={step.description}>{step.label}</button>)}</nav>:<p role="status">{unavailableReason}</p>}
 </>;
}
